/**
 * 考试列表
 * @author jzhu
 * @date 2020-02-04
 */

import React from 'react'
import { connect } from 'dva'
import moment from 'moment'
import { framework_tool, component_tool, utils_tool } from '../../../../tool'

let { Session, isType } = utils_tool;
let { WizContainer, WizAvatarUpload, ossFileUtils } = framework_tool
let {
  WizCustomSteps,
  WizForm,
  WizRow,
  WizCol,
  WizRadio,
  WizInputNumber,
  WizIcon,
  WizCheckbox,
  WizTooltip,
  WizButton,
  Wizmessage
} = component_tool
import { modelUtils } from '@/utils'
import ExamCategorySelect from '../../exam/examCategorySelect/examCategorySelect'
import './index.less'
import { Card } from 'antd';

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/online/examTemplate/examTemplateDetailUpd') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('examTemplateDetailInfo', record)
      } else {
        record = Session.get('examTemplateDetailInfo') || {}
      }
    }
    if (history.location.pathname === '/online/examTemplate/examTemplateDetailAdd') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('examTemplateDetailAdd', record)
      } else {
        record = Session.get('examTemplateDetailAdd') || {}
      }
    }
  }
  return record
}


class ExamTemplateDetail extends WizContainer {
  componentName = 'examTemplateDetail'

  constructor(props) {
    super(props)
    let record = getParamRecord(props.history);
    let categoryTypeName = '';
    if (record) {
      let { categoryType, cuttingScreenNum } = record;
      if (categoryType) {
        categoryTypeName = categoryType;
      }
      record.cuttingScreen = cuttingScreenNum > 0;
    }
    this.state = {
      categoryTypeName: categoryTypeName,
      key: 'examTemplateDetail_' + new Date().getTime(),
      totalScore: record['totalScore'],
      record: record,
      nextStep: false
    }
    this.checks = {
      shuffle: { title: '试题顺序打乱', tips: '题序随机生成，防止考试作弊。(仅针对固定考题出卷试卷)' },
      optionRandom: { title: '选择题选项打乱', tips: '单选及多选题选项顺序随机生成，防止考试作弊。' },
      cuttingScreen: { title: '切屏次数限制', tips: '限制学员切屏次数，防止考试作弊。' },
      autoMark: { title: '系统自动批阅' },
      showScore: { title: '批阅后允许学员查看分数', tips: '批阅后允许学员查看考试得分。' },
      showResult: { title: '批阅后允许学员查看通过状态', tips: '批阅后允许学员查看考试是否通过。' },
      showHistory: { title: '批阅后允许学员查看答卷记录', tips: '批阅后允许学员查看已提交的答卷记录。' },
      showAnswer: { title: '允许学员查看正确答案', tips: '学员查看答卷记录时，允许查看题目正确答案信息。' },
      resolve: { title: '允许学员查看答案解析', tips: '学员查看答卷记录时，允许查看题目答案解析信息。' }
    }
    this._examTemplateId = record.id
    this.resetTime = new Date().getTime()
  }


  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/online/examTemplate/examTemplateDetailUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('examTemplateDetailInfo', initialValue)
        this.setState({ key: initialValue?.id || '' })
      } else {
        initialValue = Session.get('examTemplateDetailInfo') || {};
      }
    }
    this.setState({ record: initialValue })
  }

  _renderCheckRow(key, getFieldDecorator) {
    // autoMark 系统自动批阅 如果编辑时,只有为草稿状态(status = 0)才可更改
    let disabled = false
    if (key === 'autoMark' && this.state.record['status'] >= 1 && !this.copyExam) {
      disabled = true
    }
    return (
      <WizRow>
        <WizCol>
          {
            getFieldDecorator(key, { initialValue: (key === 'examBeforeAuth' ? true : this.state.record[key]) })(
              <WizCheckbox key={this.resetTime + key} title={this.checks[key].title}
                defaultChecked={key === 'examBeforeAuth' ? true : this.state.record[key]}
                disabled={key === 'examBeforeAuth' ? true : disabled}>
                {this.checks[key].title}
              </WizCheckbox>
            )
          }
          {this._renderCheckTips(this.checks[key].tips)}
        </WizCol>
      </WizRow>
    )
  }

  _renderCheckTips(tips) {
    if (tips) {
      return (
        <WizTooltip title={tips}>
          <WizIcon type='question-circle-o' />
        </WizTooltip>
      )
    }
  }

  _renderCuttingScreen(form) {
    const { getFieldValue, getFieldDecorator } = form
    const { record, totalScore } = this.state
    const { cuttingScreenNum } = record || {}

    if (!getFieldValue('cuttingScreen')) {
      return null;
    }

    return (
      <WizRow>
        <WizCol span={4}>
          {getFieldDecorator('cuttingScreenNum', { initialValue: cuttingScreenNum > 0 ? cuttingScreenNum : 1 })(<WizInputNumber placeholder={'请输入切屏限制次数'} min={1} max={9999} />)}
        </WizCol>
        <WizCol span={1} className='limit-minutes-text'>次</WizCol>
      </WizRow>
    )
  }

  _columns() {

    const { record, totalScore } = this.state
    let { categoryType, categoryTypeId, scoreRule, examType=[] } = record
    let selects = categoryType && categoryTypeId ? [{
      label: categoryType,
      title: categoryType,
      key: categoryTypeId
    }] : []
    scoreRule = scoreRule ? scoreRule : 0
    return [
      {
        title: '考试模版名称',
        name: 'title',
        formItem: {
          maxLength: 25,
          rules: [{ required: true, message: '请输入考试模版名称' }]
        }
      },
      {
        title: '考试分类',
        name: 'categoryTypeId',
        formItem: {
          type: 'diy',
          selects: selects,
          diy: ExamCategorySelect,
          rules: [{ required: true, message: '请选择考试分类' }],
          onChangeRowMap: data => {
            if (data && isType(data, 'Object')) {
                this.setState({ categoryTypeName: title });
            } else {
              this.setState({ categoryTypeName: '' });
            }
          },
        }
      },
      {
        title: '考试类型',
        name: 'examTypes',
        formItem: {
          type: 'select',
          mode: 'multiple',
          rules: [{ required: true, message: '请选择考试类型' }],
          initialValue: examType
        },
        dict: [
          { code: '0', codeName: '独立考试' },
          { code: '1', codeName: '课程考试' },
          { code: '2', codeName: '练习考试' }
        ],
      },
      {
        title: '试卷总分',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            return (
              <div style={{ paddingLeft: 10 }}>{(totalScore && totalScore <= 0) ? '-' : totalScore}
                <WizTooltip title={'根据试题安排情况，自动计算试卷总分。'}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </WizTooltip>
              </div>
            )
          }
        }
      },
      {
        title: '通过分数',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <WizRow>
                <WizCol span={4}>
                  {
                    getFieldDecorator('passScore', {
                      rules: [{ required: true, message: '请输入通过分数' }],
                      initialValue: record.passScore
                    })(
                      <WizInputNumber min={1} max={999.5} />
                    )
                  }
                </WizCol>
                <WizCol span={1}>
                  <WizTooltip title={'请输入大于0且小于等于试卷总分的数值。'}>
                    <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '成绩规则',
        name: 'scoreRule',
        formItem: {
          type: 'custom',
          render: (data, form) => {
            const { getFieldDecorator } = form
            const radioStyle = {
              alignItems: 'left',
              display: 'block',
              height: '35px',
              lineHeight: '35px'
            }
            return (
              <>
                {
                  getFieldDecorator('scoreRule', {
                    rules: [{
                      required: true,
                      message: '请选择成绩规则'
                    }],
                    initialValue: scoreRule
                  })(<WizRadio.Group defaultValue={scoreRule}>
                    <WizRadio value={0} style={radioStyle}>以学员成绩的最高分计算考试通过状态</WizRadio>
                    <WizRadio value={1} style={radioStyle}>以学员成绩的平均分计算考试通过状态</WizRadio>
                  </WizRadio.Group>)
                }
              </>
            )
          }
        }
      },
      {
        title: '限制考试时长(分钟)',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <WizRow>
                <WizCol span={4}>
                  {
                    getFieldDecorator('limitMinutes', {
                      rules: [
                        { required: true, message: '请输入限制考试考试时长' },
                        { pattern: /^[0-9]{1,4}$/, message: "限制最大输入4位数" }
                      ],
                      initialValue: record.limitMinutes
                    })(
                      <WizInputNumber min={1} max={9999} />
                    )
                  }
                </WizCol>
                <WizCol span={1} className='limit-minutes-text'>分钟</WizCol>
                <WizCol span={1}>
                  <WizTooltip title={'考试用时到达后系统自动完成交卷'}>
                    <WizIcon type='question-circle-o' style={{ marginLeft: 3 }} />
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '允许重复考试',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <WizRow>
                <WizCol span={4}>
                  {
                    getFieldDecorator('count', {
                      rules: [
                        { required: true, message: '请输入允许重复考试次数' },
                        { pattern: /^[0-9]{1,4}$/, message: "限制最大输入4位数" }
                      ],
                      initialValue: record.count
                    })(
                      <WizInputNumber min={0} max={9999} />
                    )
                  }
                </WizCol>
                <WizCol span={1} className='limit-minutes-text'>次</WizCol>
                <WizCol span={1}>
                  <WizTooltip title={'允许考生多次参与考试，0次则不限制次数。'}>
                    <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: <span>
          上传封面&nbsp;
          <WizTooltip title="请上传大小不超过500KB,图片尺寸建议400*266">
            <WizIcon type="question-circle-o" />
          </WizTooltip>
        </span>,
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('questionImg', {
                  initialValue: (record && record.img) ? [
                    { fileId: record.img }
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 266}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 0.488;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过500KB!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      {
        title: '介绍',
        name: 'intro',
        dataIndex: 'intro',
        formItem: {
          type: 'textarea',
          placeholder: '选填，请提供简介内容，方便大家了解此考试',
          maxLength: 200,
          initialValue: undefined
        },
      },
      {
        title: '防作弊限制',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {this._renderCheckRow('shuffle', getFieldDecorator)}
                {this._renderCheckRow('optionRandom', getFieldDecorator)}
                {this._renderCheckRow('cuttingScreen', getFieldDecorator)}
                {this._renderCuttingScreen(form)}
              </>
            )
          }
        }
      },
      {
        title: '批阅限制',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {this._renderCheckRow('autoMark', getFieldDecorator)}
                {this._renderCheckRow('showScore', getFieldDecorator)}
                {this._renderCheckRow('showResult', getFieldDecorator)}
                {this._renderCheckRow('showHistory', getFieldDecorator)}
                {this._renderCheckRow('showAnswer', getFieldDecorator)}
                {this._renderCheckRow('resolve', getFieldDecorator)}
              </>
            )
          }
        }
      }
    ]
  }

  _onReset() {
    this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
    this.resetTime = new Date().getTime()
  }

  _fitterExamValues(values) {
    let fitterValues = {}
    Object.keys(values).forEach(key => {
      let value = values[key]
      if (value !== null && value !== undefined && value !== '' && value !== 'null') {
        fitterValues[key] = value
      }
    })
    Object.keys(this.checks).forEach(key => {
      fitterValues[key] = fitterValues[key] ? 1 : 0
    })
    fitterValues.categoryTypeId = fitterValues.categoryTypeId
    /**
     * 图片参数处理
     */
    let questionImg = fitterValues['questionImg']
    if (questionImg && questionImg.length) {
      fitterValues['img'] = questionImg[0]['fileId']
      delete fitterValues['questionImg']
    }
    if (!fitterValues.cuttingScreen) {
      fitterValues.cuttingScreenNum = 0
    }
    return fitterValues
  }

  _onSave(nextStep) {
    const { record, totalScore } = this.state
    const { state } = record
    let form = this.refs.form
    if (form) {
      form.validateFields((err, values) => {
        let imgFile = values.questionImg && values.questionImg.length ? values.questionImg[0] : ''
        if (!err) {
          let params = this._fitterExamValues(values)
          params.fileMimeType = imgFile.fileType
          params.fileName = imgFile.name
          params.fileSize = imgFile.size
          params.fileUri = imgFile.sysUrl
          //模版状态 有效
          params.state = state || 0
          this.setState({ nextStep, record: params }, () => {
            log.info('pppp:',params)
            if (this._examTemplateId) {
              params.pathUrl = 'examTemplate/updateExamTemplate'
              this.doAction({
                path: 'examTemplate/updateExamTemplate',
                payload: {
                  key: 'examTemplate@update',
                  apiParams: { id: this._examTemplateId, ...params, totalScore: totalScore }
                }
              })
            } else {
              params.pathUrl = 'examTemplate/createExamTemplate'
              this.doAction({
                path: 'examTemplate/createExamTemplate',
                payload: {
                  key: 'examTemplate@create',
                  apiParams: { ...params }
                }
              })
            }
          })
        } else {
          if (err) {
            const { spaceTime, authenticationCount } = err;
            if (spaceTime && spaceTime.errors && spaceTime.errors instanceof Array && spaceTime.errors.length > 0) {
              const { message, field } = spaceTime.errors[0];
              form.setFields({
                'spaceTime': {
                  value: values['spaceTime'],
                  errors: [
                    new Error(message)
                  ]
                }
              });
            }
            if (authenticationCount && authenticationCount.errors && authenticationCount.errors instanceof Array && authenticationCount.errors.length > 0) {
              const { message, field } = spaceTime.errors[0];
              form.setFields({
                'authenticationCount': {
                  value: values['spaceTime'],
                  errors: [
                    new Error(message)
                  ]
                }
              });
            }
          }
        }
      })
    }
  }

  _renderFooter = () => {
    return (
      <WizRow className='form-btns col-item'>
        <WizCol span={24}>
          <WizButton title='下一步' type='primary' htmlType='submit' onClick={e => this._onSave(true)}>保存并进入下一步</WizButton>
          <WizButton title='保存' htmlType='submit' onClick={e => this._onSave(false)}>保存并返回</WizButton>
          <WizButton title='重置' onClick={e => this._onReset()}>重置</WizButton>
        </WizCol>
      </WizRow>
    )
  }
  _render() {
    let columns = this._columns()
    let formProps = {
      key: this.state.key || '',
      ref: 'form',
      columns,
      record: this.state.record,
      preview: null,
      footer: this._renderFooter(),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 15 }
      }
    }
    let wizCustomStepsProps = {
      header: [
        { title: '考试信息' },
        { title: '考试章节' }
      ],
      current: 0,
      content: <WizForm {...formProps} />,
      footer: null
    }
    return <WizCustomSteps {...wizCustomStepsProps} />
  }

  propsAndStateOnChange = {
    createExamTemplate: this._createExamTemplateOnChange.bind(this),
    updateExamTemplate: this._updateExamTemplateOnChange.bind(this)
  }

  _createExamTemplateOnChange(nextProps, nextState) {
    if (nextProps.createExamTemplate.code === 1) {
      this._examTemplateId = nextProps.createExamTemplate.data
      if (this.state.nextStep) {
        this._nextPage()
      } else {
        this.jumpPage('replaceAndDelCrumb', '/online/examTemplate')
      }
    }
    return true
  }

  _updateExamTemplateOnChange(nextProps, nextState) {
    if (nextProps.updateExamTemplate.code === 1) {
      if (this.state.nextStep) {
        this._nextPage()
      } else {
        this.jumpPage('replaceAndDelCrumb', '/online/examTemplate')
      }
      nextState.nextStep = false
    } else {
      wizNotice.error(nextProps.updateExamTemplate.msg)
      return false;
    }
    return true
  }

  _nextPage() {
    this.dispatch({
      type: 'tablayoutModels/clearMultipleTopBar', // 项目内自行构建的models,自行实现逻辑
      payload: {
          routerKey: ['/online/examTemplate/examTemplateChapterUpd'],
      },
      callBack: () => {
        this.jumpPage(
          'replaceAndDelCrumb',
          '/online/examTemplate/examTemplateChapter' + (this._examTemplateId ? 'Upd' : 'Add'),
          { ...this.state.record, id: this._examTemplateId }
        )
      }
  })

  }
}

const mapStateToProps = (state, ownProps) => {
  const { examTemplate } = state
  const createExamTemplate = modelUtils.getModelEntity(examTemplate, 'examTemplate@create')
  const updateExamTemplate = modelUtils.getModelEntity(examTemplate, 'examTemplate@update')
  const load = modelUtils.getLoadingState(state, 'exam')
  return {
    createExamTemplate,
    updateExamTemplate,
    ...load
  }
}

export default connect(mapStateToProps)(ExamTemplateDetail)
